import { call, put, takeEvery, select } from "redux-saga/effects";

import { getUsersActionsFilters, loaderUserActions, loaderUserActionsFilters, setUsersActions, setUsersActionsFilters } from "./actions";
import { GET_USERS_ACTIONS, GET_USERS_ACTIONS_FILTERS } from "./actionTypes";
import { getErrorMessage, showErrorMessage } from "../../helpers/utils";
import { getUsersActions, getUsersActionsFiltersQuery } from "../../helpers/jwt_helper";

function* onGetUsersActionsFilters({ }) {
  try {
    yield put(loaderUserActionsFilters());
    let response = yield call(getUsersActionsFiltersQuery, {});
    
    if (response?.options) {
      response = response.options
    } else {
      response = []
    }

    yield put(setUsersActionsFilters(response));
    yield put(loaderUserActionsFilters());
  } catch (error) {
    yield put(loaderUserActionsFilters());
  }
}

function* onGetUsersActions({ payload: data }) {
  try {
    yield put(loaderUserActions());
    let response = yield call(getUsersActions, {
      page: data.page,
      size: data.sizePerPage,
      ordering: data.ordering,
      ...(data?.timestamp_gte && { timestamp_gte: data.timestamp_gte }),
      ...(data?.timestamp_lte && { timestamp_lte: data.timestamp_lte }),
      ...(data?.user && { user: data.user }),
      ...(data?.action && { action: data.action }),
    });

    if (response.results) {
      response = {
        ...data,
        ...response,
        results: response.results.map(i => ({
          ...i,
          created_at: new Date(i.created_at).toDateString(),
        })),
      };
    } else {
      response = {
        results: response,
      };
    }

    yield put(setUsersActions(response));
    yield put(loaderUserActions());
  } catch (error) {
    yield put(loaderUserActions());
  }
}

function* userActionsSaga() {
  yield takeEvery(GET_USERS_ACTIONS, onGetUsersActions);
  yield takeEvery(GET_USERS_ACTIONS_FILTERS, onGetUsersActionsFilters);
}

export default userActionsSaga;
